import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { InputAppDataService } from '@monorepo/services';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  FetchHealthCheckStatusAndUpdate,
  InputAppMetadataActionTypes,
  UpdateHealthCheckStatus,
} from './metadata.actions';

@Injectable({
  providedIn: 'root',
})
export class InputAppMetadataEffects {
  constructor(private action$: Actions, private inputAppDataService: InputAppDataService) {}

  FetchHealthCheckStatusAndUpdate$ = createEffect(() =>
    this.action$.pipe(
      ofType<FetchHealthCheckStatusAndUpdate>(InputAppMetadataActionTypes.FetchHealthCheckStatusAndUpdate),
      switchMap(() =>
        from(this.inputAppDataService.healthCheck()).pipe(
          take(1),
          map(() => new UpdateHealthCheckStatus(true)),
          catchError(() => of(new UpdateHealthCheckStatus(false))),
        ),
      ),
    ),
  );
}
